// extracted by mini-css-extract-plugin
module.exports = {"scrolledContainer":"scrolled-container_scrolledContainer__IZ--Q"};